
import { clone } from "@/modules/Etiquetas/services/etiquetaDefinition";

export default {
  name: "EtiquetaFormatSettings",
  props: {
    definition: { type: Object, required: true },
  },
  data() {
    return {
      advanced: false,
      autoFitRoll: false,
      margins: [
        { key: "margem_superior_mm", label: "Superior" },
        { key: "margem_direita_mm", label: "Direita" },
        { key: "margem_inferior_mm", label: "Inferior" },
        { key: "margem_esquerda_mm", label: "Esquerda" },
      ],
    };
  },
  created() {
    this.autoFitRoll = this.shouldStartWithAutoFit();
  },
  computed: {
    page() {
      return this.definition.pagina || {};
    },
    label() {
      return this.definition.etiqueta || {};
    },
    totalLabels() {
      return Number(this.page.colunas || 1) * Number(this.page.linhas || 1);
    },
    usedWidthNumber() {
      return (
        Number(this.page.margem_esquerda_mm || 0) +
        Number(this.page.margem_direita_mm || 0) +
        Number(this.page.colunas || 1) * Number(this.label.largura_mm || 0) +
        Math.max(0, Number(this.page.colunas || 1) - 1) *
          Number(this.page.espacamento_horizontal_mm || 0)
      );
    },
    usedHeightNumber() {
      return (
        Number(this.page.margem_superior_mm || 0) +
        Number(this.page.margem_inferior_mm || 0) +
        Number(this.page.linhas || 1) * Number(this.label.altura_mm || 0) +
        Math.max(0, Number(this.page.linhas || 1) - 1) *
          Number(this.page.espacamento_vertical_mm || 0)
      );
    },
    usedWidth() {
      return this.usedWidthNumber.toFixed(1).replace(".0", "");
    },
    usedHeight() {
      return this.usedHeightNumber.toFixed(1).replace(".0", "");
    },
    fitsPage() {
      return (
        this.usedWidthNumber <= Number(this.page.largura_mm || 0) + 0.5 &&
        this.usedHeightNumber <= Number(this.page.altura_mm || 0) + 0.5
      );
    },
  },
  methods: {
    set(path, value, { manualPageSize = false } = {}) {
      const next = clone(this.definition);
      this.setPath(next, path, value);

      if (manualPageSize) this.autoFitRoll = false;
      else if (this.autoFitRoll && this.affectsDistribution(path)) {
        this.fitPageToDistribution(next);
      }

      this.emitUpdate(next);
    },
    setNumber(path, value) {
      const number = Number(value);
      if (!Number.isNaN(number)) {
        this.set(path, number, {
          manualPageSize: ["pagina.largura_mm", "pagina.altura_mm"].includes(
            path
          ),
        });
      }
    },
    setInteger(path, value) {
      const number = Number.parseInt(value, 10);
      if (!Number.isNaN(number)) this.set(path, number);
    },
    setAutoFitRoll(enabled) {
      this.autoFitRoll = Boolean(enabled);
      if (!this.autoFitRoll) return;

      const next = clone(this.definition);
      this.fitPageToDistribution(next);
      this.emitUpdate(next);
    },
    shouldStartWithAutoFit() {
      const usage = this.distributionSize(this.definition);
      const page = this.definition.pagina || {};
      const rows = Number(page.linhas || 1);

      return (
        rows === 1 &&
        Math.abs(Number(page.largura_mm || 0) - usage.width) <= 0.5 &&
        Math.abs(Number(page.altura_mm || 0) - usage.height) <= 0.5
      );
    },
    affectsDistribution(path) {
      return [
        "etiqueta.largura_mm",
        "etiqueta.altura_mm",
        "pagina.colunas",
        "pagina.linhas",
        "pagina.margem_superior_mm",
        "pagina.margem_direita_mm",
        "pagina.margem_inferior_mm",
        "pagina.margem_esquerda_mm",
        "pagina.espacamento_horizontal_mm",
        "pagina.espacamento_vertical_mm",
      ].includes(path);
    },
    distributionSize(definition) {
      const page = definition.pagina || {};
      const label = definition.etiqueta || {};
      const columns = Math.max(1, Number(page.colunas || 1));
      const rows = Math.max(1, Number(page.linhas || 1));
      const width =
        Number(page.margem_esquerda_mm || 0) +
        Number(page.margem_direita_mm || 0) +
        columns * Number(label.largura_mm || 0) +
        Math.max(0, columns - 1) * Number(page.espacamento_horizontal_mm || 0);
      const height =
        Number(page.margem_superior_mm || 0) +
        Number(page.margem_inferior_mm || 0) +
        rows * Number(label.altura_mm || 0) +
        Math.max(0, rows - 1) * Number(page.espacamento_vertical_mm || 0);

      return {
        width: Number(width.toFixed(2)),
        height: Number(height.toFixed(2)),
      };
    },
    fitPageToDistribution(definition) {
      if (!definition.pagina) this.$set(definition, "pagina", {});
      const usage = this.distributionSize(definition);
      definition.pagina.largura_mm = usage.width;
      definition.pagina.altura_mm = usage.height;
    },
    setPath(target, path, value) {
      const parts = path.split(".");
      const last = parts.pop();
      let current = target;
      parts.forEach((part) => {
        if (!current[part]) this.$set(current, part, {});
        current = current[part];
      });
      current[last] = value;
    },
    emitUpdate(next) {
      this.$emit("change-start");
      this.$emit("update", next);
    },
  },
};
